import React from 'react';

import { shotFor } from './shots';
import './feature-screen.scss';

/**
 * The real screen a Feature Matrix row switches on, with its control
 * outlined — shown in the hover card on a feature name (Alex, 2026-10-28:
 * "the actual screen with sample data, the relevant ones highlighted").
 *
 * The images are screenshots of the real pages rendered with SAMPLE data, made
 * by scripts/feature-previews/capture.cjs. Re-run it when a page changes. Only
 * the URLs are bundled; an image downloads when its card first opens.
 */

export default function FeatureScreen({ featureKey, label }) {
  const src = shotFor(featureKey);

  if (!src) {
    return (
      <div className="fs-frame fs-frame--empty" aria-hidden="true">
        <span>Not built yet</span>
      </div>
    );
  }

  return (
    <div className="fs-frame">
      <img className="fs-shot" src={src} alt={`Where ${label} is in the app`} width="880" height="520" />
    </div>
  );
}
